import {
  LOADING_ARRAY,
  LIST_COMMUNITY_DOOR_ACCESS_IDS_REQUEST,
  LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE,
  REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE,
  ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// communityId -> [doorAccessIds, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_COMMUNITY_DOOR_ACCESS_IDS_REQUEST:
      return {
        ...state,
        [action.communityId]: state[action.communityId] || LOADING_ARRAY,
      }

    case LIST_COMMUNITY_DOOR_ACCESS_IDS_RESPONSE:
      return {
        ...state,
        [action.communityId]: action.accessIds || [],
      }

    case REMOVE_COMMUNITY_DOOR_ACCESS_RESPONSE:
      return {
        ...state,
        [action.communityId]: state[action.communityId].filter((id) => id !== action.accessId),
      }

    case ADD_COMMUNITY_DOOR_ACCESSES_RESPONSE:
      return {
        ...state,
        [action.communityId]: action.accessIds,
      }

    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
